var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"app"}},[_c('RedesEcontatos'),_c('Header'),_c('article',{attrs:{"id":"page"}},[_c('router-view')],1),_c('FiquePorDentro'),_c('Footer'),(_vm.$store.state.asideGaleria.contents)?_c('AsideGaleria'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }